import styled, { css } from "styled-components";

// styles
import { convertPxToRem } from "frontend/components/helpers";

/*
    Using Max Height instead of transform:translateY()
        to remove the need to position/overlay previous and subsequent sibling elements
        https://stackoverflow.com/a/8331169
        This has the added benefit of truly being self-contained
        does not rely on elements outside of attribution element

    Caution:
        max-height must be greater than actual height
        if max-height is set too high, it will impact the speed of reveal.
*/
const ATTRIBUTION_AREA_HEIGHT = 300; // Choosing a max-height that works for both photo and icon attributions

export const DrawerRevealSlideStyled = styled.div`
    max-height: 0px;
    overflow: hidden;

    ${({ isVisible }) =>
        isVisible &&
        css`
            transition: max-height 700ms ease-in-out;
            max-height: ${convertPxToRem({ px: ATTRIBUTION_AREA_HEIGHT })};
            margin-bottom: ${convertPxToRem({ px: 24 })};
        `}
`;
